import React from 'react';
import { TaskState } from 'gql/graphql';
import { VIEWABLE_LENDER_ITEMS, APPRAISAL_ITEMS, TITLE_ITEMS, INSURANCE_ITEMS } from '../utils/constants';
import { createDocumentValidations } from '../utils/documentValidations';
import { TaskStateIcon } from './SharedComponents';

interface LenderItemProps {
  item: any;
  tasks: any[];
  loanDocs: any[];
  setShowLoanDetailsModal: (show: boolean) => void;
}

export const LenderTaskItem: React.FC<LenderItemProps> = ({
  item,
  tasks,
  loanDocs,
  setShowLoanDetailsModal
}) => {
  const documentValidations = createDocumentValidations(tasks, loanDocs);

  // Determinar el cursor para el item
  const getItemCursor = () => {
    if (APPRAISAL_ITEMS.includes(item.key)) {
      return documentValidations.showDocAppraisal() ? 'pointer' : 'default';
    }
    
    if (TITLE_ITEMS.includes(item.key)) {
      return documentValidations.showDocTitle() ? 'pointer' : 'default';
    }
    
    if (INSURANCE_ITEMS.includes(item.key)) {
      return documentValidations.showDocInsurance() ? 'pointer' : 'default';
    }
    
    return ((item.loanDoc?.file?.url || item.loanDoc?.files?.length > 0) && !item.loanDoc?.hidden) ? 'pointer' : 'default';
  };

  const handleItemClick = () => {
    // Caso especial para closing_docs
    if (item.key === 'closing_docs' && item.state === TaskState.Approved) {
      setShowLoanDetailsModal(true);
      return;
    }

    // Logica para archivos únicos
    if (item.loanDoc?.file?.url && !item.loanDoc?.hidden && item?.numberOfFiles === 1) {
      const documentHandlers = {
        appraisal_ordered: () => documentValidations.showDocAppraisal(),
        appraisal_approved: () => documentValidations.showDocAppraisal(),
        title_requested: () => documentValidations.showDocTitle(),
        title_verified: () => documentValidations.showDocTitle(),
        title_cleared: () => documentValidations.showDocTitle(),
        insurance_verified: () => documentValidations.showDocInsurance()
      };

      const initialDocs = {
        pre_approval_letter: () => true,
        term_sheet: () => true
      }

      const handler = documentHandlers[item.key as keyof typeof documentHandlers];
      if (handler && handler()) {
        window.open(item.loanDoc.file.url, '_blank');
        return;
      }
      else if (initialDocs[item.key as keyof typeof initialDocs]) {
        window.open(`${item.loanDoc.file.url}?preview=true&app=borrower`, '_blank');
        return;
      }
    }

    // Logica para múltiples archivos
    if (item.loanDoc?.file?.url && !item.loanDoc?.hidden && item?.numberOfFiles > 1) {
      setShowLoanDetailsModal(true);
      return;
    }
  };

  const renderActionLabel = () => {
    if (item.state === 'BLOCKED' && !item.loanDoc) {
      return <b>| Complete <strong>&#8594;</strong></b>;
    }

    if (VIEWABLE_LENDER_ITEMS.includes(item.key) && item.loanDoc?.file?.url && !item.loanDoc.hidden) {
      const validationMap = {
        appraisal_ordered: documentValidations.showDocAppraisal,
        appraisal_approved: documentValidations.showDocAppraisal,
        title_requested: documentValidations.showDocTitle,
        title_verified: documentValidations.showDocTitle,
        title_cleared: documentValidations.showDocTitle,
        insurance_verified: documentValidations.showDocInsurance
      };

      const validation = validationMap[item.key as keyof typeof validationMap];
      if (validation && validation()) {
        return <b>| View <strong>&#8594;</strong></b>;
      }
    }

    if (!VIEWABLE_LENDER_ITEMS.includes(item.key) && item.loanDoc?.file?.url && !item.loanDoc.hidden) {
      return <b>| View <strong>&#8594;</strong></b>;
    }

    return null;
  };

  return (
    <div
      className={`task-item task-item-${item.state}`}
      style={{ cursor: getItemCursor() }}
      onClick={handleItemClick}
    >
      <TaskStateIcon state={item.state} />
      <span>{item.text}</span>
      {renderActionLabel()}
    </div>
  );
};